import defOpts from './default';

const absoluteLabelFormatter = function () {
  return this.value;
};

const options = (roundingDecimals = 2) => {
  const defaultOptions = defOpts(roundingDecimals);

  return {
    ...defaultOptions,
    chart: {
      ...defaultOptions.chart,
      spacingRight: 30,
    },

    yAxis: {
      ...defaultOptions.yAxis,
      labels: {
        x: 25,
        formatter: absoluteLabelFormatter,
      },
    },
    plotOptions: {
      ...defaultOptions.plotOptions,
      series: {
        ...defaultOptions.plotOptions.series,
        compare: null,
      },
    },
    tooltip: {
      ...defaultOptions.tooltip,
      pointFormatter: function () {
        const defaults = ['price_return', 'close'];
        const metricName = (this.series?.options?.metric || '').replaceAll('_', ' ');
        const metric = !defaults.includes(this.series?.options?.metric) ? `(${metricName})` : '';

        const value = Number(this.y).toFixed(roundingDecimals);

        return `<b>${this.series.name} ${metric}: ${value}</b>`;
      },
    },
  };
};

export default options;
